
import HeaderTitle from '@/common-utils/components/renders/modal/components/headers/HeaderTitle/HeaderTitle';
import { Modal, ModalBody, ModalContent, ModalTrigger } from '@/common-utils/components/ui/modal';
import FooterForm from '@/common-utils/components/renders/modal/components/footers/FooterForm/FooterForm';
import Entity from '@/common-utils/components/renders/entity/Entity';
import { cn } from '@/common-utils/libraries/tailwind/utils';
import PropTypes from 'prop-types';
import actionsSubscriptions from '../../api/actionsSubscriptions';
import DateTimePicker from '@/common-utils/components/renders/dateTimePicker/DateTimePicker';
import { useState } from 'react';
import { DateTime } from 'luxon';
import { useToast } from '@/common-utils/hooks/use-toast';
import { nsSubscription } from '@/app/i18n/namespaces';

/**
 * @param {JSX.Element} trigger element that triggers modal opening
 * @returns {JSX.Element} ModalScheduledTerminateSubscription Component
 */
function ModalScheduledTerminateSubscription({ trigger, isOpen, setIsOpen, subscriptionId, setLaunchRefetch }) {


    // Toast
    const { toast } = useToast();

    // State
    const [dateTimeValues, setDateTimeValues] = useState(undefined);

    // API Calls
    const onSuccess = () => {
        setIsOpen(false);
        setLaunchRefetch(true);
        toast({
            description: <Entity
                entity={'modal.terminate.scheduled.success'}
                namespace={nsSubscription}
                data={{
                    date: DateTime.fromISO(dateTimeValues.startDateSelected).toLocaleString(DateTime.DATE_SHORT)
                }}
            />,
            variant: 'success'
        });
    };
    const onError = () => {
        setIsOpen(false);
        toast({
            description: <Entity entity={'modal.terminate.scheduled.error'} namespace={nsSubscription} />,
            variant: 'danger'
        });
    };
    const submitScheduledTerminateSubscription = actionsSubscriptions.scheduledTerminateSubscription(onSuccess, onError);


    // Renders
    const content =
        <ModalContent className={cn('max-w-lg')}>
            <HeaderTitle title={'modal.terminate.title'} namespace={nsSubscription} />
            <ModalBody>
                <div className={'flex flex-col items-center'}>
                    <Entity entity={'modal.terminate.scheduled.text'} namespace={nsSubscription} />

                    <DateTimePicker
                        setDateTimeValues={setDateTimeValues}
                        rangeDisabled={(date) => date <= new Date()}
                        presetTime={'10:00'}
                    />
                    {
                        dateTimeValues && dateTimeValues.startDateSelected &&
                        <Entity
                            entity={'modal.terminate.scheduled.summary'}
                            data={{
                                date: DateTime.fromISO(dateTimeValues.startDateSelected).toLocaleString(DateTime.DATE_SHORT)
                            }}
                            namespace={nsSubscription}
                            className='text-base mt-4'
                        />
                    }
                </div>
            </ModalBody>
            <FooterForm
                onSubmit={() => submitScheduledTerminateSubscription.mutate({
                    subscriptionId,
                    resiliationDate: DateTime.fromISO(dateTimeValues.startDateSelected).toISO({ includeOffset: false })
                })}
                isSubmitting={submitScheduledTerminateSubscription.isLoading}
                isSubmitDisabled={submitScheduledTerminateSubscription.isLoading}
            />
        </ModalContent>;

    if (trigger) {
        return (
            <Modal>
                <ModalTrigger>{trigger}</ModalTrigger>
                {content}
            </Modal>
        );
    }

    return (
        <Modal open={isOpen} onOpenChange={setIsOpen}>
            {content}
        </Modal>
    );
}

ModalScheduledTerminateSubscription.propTypes = {
    trigger: PropTypes.element,
    isOpen: PropTypes.bool,
    setIsOpen: PropTypes.func,
    subscriptionId: PropTypes.string,
    setLaunchRefetch: PropTypes.func
};

export default ModalScheduledTerminateSubscription;